/* ==========================================================================
   JADUZAR INK — interaction layer
   No dependencies. Everything degrades to a working page without it.
   ========================================================================== */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Scroll reveal ---------------------------------------------------- */
  const revealables = () => document.querySelectorAll('[data-ji-reveal]:not(.is-revealed)');

  function initReveal() {
    const items = revealables();
    if (!items.length) return;
    items.forEach((el) => el.classList.add('is-revealed'));
  }

  /* ---- Header: transparent over the hero, solid once scrolled ----------- */
  function initHeader() {
    const header = document.getElementById('header-group');
    if (!header) return;

    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:100%;pointer-events:none;';
    document.body.prepend(sentinel);

    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      ([entry]) => header.classList.toggle('is-stuck', !entry.isIntersecting),
      { threshold: 0 }
    );
    io.observe(sentinel);
  }

  /* ---- Service index: hover preview ------------------------------------
     Desktop pointer only. The thumbnail in each row covers touch devices. */
  function initIndex() {
    if (reduced.matches) return;
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;

    document.querySelectorAll('[data-ji-index]').forEach((root) => {
      const preview = root.querySelector('[data-ji-index-preview]');
      if (!preview) return;
      const frames = preview.querySelectorAll('[data-preview]');
      if (!frames.length) return;

      /* The first frame is shown from the start, so the column is never
         empty; hovering swaps it and leaving restores the first. */
      const show = (i) =>
        frames.forEach((f) => f.classList.toggle('is-shown', f.dataset.preview === i));
      const hide = () => show('0');

      root.querySelectorAll('[data-ji-index-item]').forEach((item) => {
        item.addEventListener('pointerenter', () => show(item.dataset.index));
        item.addEventListener('focus', () => show(item.dataset.index));
      });

      const list = root.querySelector('.ji-index__list');
      if (list) {
        list.addEventListener('pointerleave', hide);
        list.addEventListener('focusout', (e) => {
          if (!list.contains(e.relatedTarget)) hide();
        });
      }
    });
  }

  /* ---- Before / after ---------------------------------------------------
     The range input owns the state; we only mirror it into a CSS variable. */
  function initCompare() {
    document.querySelectorAll('[data-ji-compare]').forEach((root) => {
      const input = root.querySelector('[data-ji-compare-input]');
      if (!input) return;
      const sync = () => root.style.setProperty('--pos', `${input.value}%`);
      input.addEventListener('input', sync);
      sync();
    });
  }

  function init() {
    initReveal();
    initHeader();
    initIndex();
    initCompare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Shopify Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', initReveal);
})();

/* ==========================================================================
   Mobile booking bar — reveals once the booking panel scrolls out of view.
   ========================================================================== */
(() => {
  function init() {
    const bar = document.querySelector('[data-ji-bookbar]');
    const panel = document.querySelector('.ji-product__sticky');
    const submit = document.querySelector('[data-ji-submit]');
    if (!bar || !panel || !submit) return;
    if (!('IntersectionObserver' in window)) return;

    bar.hidden = false;

    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('is-shown', !entry.isIntersecting),
      { threshold: 0 }
    ).observe(panel);

    const jump = bar.querySelector('[data-ji-bookbar-jump]');
    if (jump) {
      jump.addEventListener('click', (e) => {
        e.preventDefault();
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        submit.focus({ preventScroll: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
